// The delivery form's draft, as pure functions over the column definitions the API serves.
//
// A draft holds one string per stored column, keyed as the API keys them, so the form has nothing
// of its own to name (AC9). Derived columns are not in the draft: they are read from the row and
// shown, never typed.

import { isIsoDate } from './cells.js';

export const stored = (columns) => columns.filter((column) => !column.derived);

export const emptyDraft = (columns) =>
  Object.fromEntries(stored(columns).map((column) => [column.key, '']));

export const fromRow = (columns, row) =>
  Object.fromEntries(stored(columns).map((column) => [column.key, row.values[column.key] ?? '']));

// What is sent. Blanks are dropped rather than sent as empty strings: the server strips them
// anyway, and a row that carries only the keys it has a value for is what the table reads back.
export const toValues = (draft) =>
  Object.fromEntries(
    Object.entries(draft)
      .map(([key, value]) => [key, value.trim()])
      .filter(([, value]) => value !== ''),
  );

// Which control a column is asked for with. A choice is a select over the served options; a
// multiline column a textarea; a date column the picker, which speaks ISO - the form the server
// stores - unless the value is something else ("TBC"), which a text input can show and a picker
// would blank. Nothing here names a column: the hints are the definition's.
export function controlFor(column, value) {
  if (column.kind === 'choice') return 'select';
  if (column.multiline) return 'textarea';
  if (column.kind === 'date' && (value === '' || isIsoDate(value))) return 'date';
  return 'text';
}

// A row with nothing in it is not worth a save. One value is enough: which columns matter is the
// spreadsheet's business, not the form's.
export const hasContent = (draft) => Object.keys(toValues(draft)).length > 0;
